<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="js">
import { inject } from 'vue';
import { useModalStore } from '@/stores/modal.store';
import { MODAL_CONFIRM } from '@/const';
import { storeToRefs } from 'pinia';

const autoStore = inject('autoStore');

const { customVariables, variableTypeList } = storeToRefs(autoStore);

const modalStore = useModalStore();

function openVariableModal(itemIndex) {
  modalStore.openModal("VariableModal", {
    customVariable: customVariables.value?.[itemIndex] ?? itemIndex,
    variableTypeList: variableTypeList,
  }).then(({ event, params }) => {
    if (event !== 'save') return;

    autoStore.createOrUpdateCustomVar(params, itemIndex);

    modalStore.closeModal();
  }).catch(() => {});
}

function deleteVariable(itemIndex) {
  modalStore.openModal('ConfirmModal', {
    title: "Вы действительно хотите удалить эту переменную?",
    btnConfirm: "Удалить",
  }).then(({ event }) => {
    if (event !== MODAL_CONFIRM) return;

    customVariables.value.splice(itemIndex, 1);
    modalStore.closeModal();
  }).catch(() => {});
}

</script>

<template>
  <div class="autoform-variables">
    <div class="d-flex justify-content-between align-items-center input-btns">
      <div class="add-btn" @click="openVariableModal()">
        <img src="@/assets/img/plus-ico.svg" alt="plus-ico.svg" />
        Создать переменную
      </div>
    </div>
    <div class="table-responsive">
      <table class="table gray-table">
        <thead>
          <tr>
            <th>Наименование</th>
            <th>Тип</th>
            <th>Значение по умолчанию</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(variable, index) in customVariables" :key="index">
            <td>
              {{ variable.title }}
            </td>
            <td>
              {{ variableTypeList[variable.type] }}
            </td>
            <td>
              {{ variable.default_value }}
            </td>
            <td>
              <div class="table-buttons">
                <div class="table-button"
                  v-if="variable.type != 'array'"
                  @click="openVariableModal(index)"
                >
                  <span class="edit-ico" />
                </div>
                <div class="table-button" @click="deleteVariable(index)">
                  <span class="delite-ico" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
